<template>
  <!-- Hero Section with Slider -->
  <div
    class="relative bg-cover bg-center -mb-14"
    :style="{ backgroundImage: `url(${slides[activeIndex].image})` }"
  >
    <div class="absolute inset-0 bg-black bg-opacity-50"></div>
    <div
      class="relative z-10 flex flex-col items-center justify-center h-screen text-center text-white"
    >
      <!-- Typing Animation Section -->
      <h1 class="text-4xl md:text-6xl font-bold mb-2">
        {{ displayedText }}<span class="cursor">|</span>
      </h1>
      <!-- Subtext -->
      <p class="text-xl md:text-xl mb-8 mt-4">
        Barka U. Mshelia collaborates with top global firms to redefine their strategies for success <br />
        while also mentoring aspiring CEO's, equipping them with the insights and tools needed to navigate <br>
        and excel in the business world.
      </p>
      <!-- Buttons -->
      <div class="flex space-x-4">
        <router-link
          to="/mshel-club"
          class="px-4 py-2 bg-gradient text-xl hover:bg-purple-800 text-white font-semibold rounded-lg transition-transform hover:scale-110 focus:outline-none"
        >
          Mshel club
      </router-link>
        <!-- <button
          class="px-4 py-2 text-xl hover:bg-transparent hover:border-2 text-white font-semibold rounded-lg transition-transform hover:scale-110 focus:outline-none"
        >
          Book now &nbsp; <i class="fa-solid fa-arrow-right"></i>
        </button> -->
      </div>
    </div>

    <!-- Navigation Arrows -->
    <!-- <button
      @click="prevSlide"
      class="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl"
    >
      &#10094;
    </button>
    <button
      @click="nextSlide"
      class="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl"
    >
      &#10095;
    </button> -->
  </div>

  <!-- Welcome to the official site of Barka -->
  <div class="bg-white">
    <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-10 mb-10">
      <h1 class="text-center text-lg font-extrabold mt-10">
        Welcome to the Official Site of <br />
        Barka U Mshelia
      </h1>
      <p class="text-center text-2xl mt-2">
        Step into the world of Barka U. Mshelia and find inspiration in the journey.
      </p>
      <p class="text-center text-2xl mt-3">
        Learn more about the inspiration, achievements and ventures of one of the globe's <br> leading real estate investor and business expert.
      </p>
    </div>
  </div>

  <!-- Meet Barka U. Mshelia -->
  <meetBarka />

  <!-- 7 Perfect Quote  -->
  <perfectQuotes />

  <!-- Barka U. Mshelia Brand -->
  <barkaBrand />

  <!-- Featured videos -->
  <!-- <featuredVideos /> -->
  
  <!-- GMD Banner -->
  <div class="bg-white">
  <div class="md:px-10 max-w-screen-2xl mx-auto py-4 mt-10 mb-10">
    <img
      src="../assets/images/gmd-banner.png"
      alt="GMD Banner"
      class="w-full h-auto object-contain"
    />
  </div>
</div>

  <!-- About family section -->
  <aboutFamily />

  <!-- Discover your path -->
  <discoverPath />

  <!-- Why Coaching works -->
  <whyCoaching />
</template>

<script>
import meetBarka from "../components/meetBarka.vue";
import barkaBrand from "../components/barkaBrand.vue";
import discoverPath from "../components/discoverPath.vue";
import whyCoaching from "../components/whyCoaching.vue";
import featuredVideos from "../components/featuredVideos.vue";
import aboutFamily from "../components/aboutFamily.vue";
import perfectQuotes from "../components/perfectQuotes.vue";

export default {
  components: {
    meetBarka,
    barkaBrand,
    discoverPath,
    whyCoaching,
    featuredVideos,
    aboutFamily,
    perfectQuotes,
  },
  data() {
    return {
      slides: [
        { id: 1, image: require("../assets/images/gmd-hero.png") },
        { id: 2, image: require("../assets/images/gmd-hero.png") },
        { id: 3, image: require("../assets/images/gmd-hero.png") },
      ],
      activeIndex: 0,
      texts: [
        "REALESTATE INVESTMENT COACH",
        "PUBLIC SPEAKER",
        "INSPIRING LEADER",
        "LEADING STRATEGIST IN LAND BANKING",
        "PYD INVESTOR",
      ],
      displayedText: "",
      currentIndex: 0,
      isErasing: false,
      speed: 22,
      delayBetweenWords: 1000,
      slideInterval: null,
    };
  },
  mounted() {
    this.typingEffect();
    this.startSlideShow();
  },
  beforeUnmount() {
    clearInterval(this.slideInterval);
  },
  methods: {
    typingEffect() {
      const currentText = this.texts[this.currentIndex];
      if (!this.isErasing && this.displayedText.length < currentText.length) {
        this.displayedText = currentText.substring(
          0,
          this.displayedText.length + 1
        );
        setTimeout(this.typingEffect, this.speed);
      } else if (this.isErasing && this.displayedText.length > 0) {
        this.displayedText = currentText.substring(
          0,
          this.displayedText.length - 1
        );
        setTimeout(this.typingEffect, this.speed);
      } else if (
        !this.isErasing &&
        this.displayedText.length === currentText.length
      ) {
        setTimeout(() => {
          this.isErasing = true;
          this.typingEffect();
        }, this.delayBetweenWords);
      } else if (this.isErasing && this.displayedText.length === 0) {
        this.isErasing = false;
        this.currentIndex = (this.currentIndex + 1) % this.texts.length;
        this.typingEffect();
      }
    },
    startSlideShow() {
      this.slideInterval = setInterval(this.nextSlide, 3000);
    },
    nextSlide() {
      clearInterval(this.slideInterval);
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      this.startSlideShow();
    },
    prevSlide() {
      clearInterval(this.slideInterval);
      this.activeIndex =
        (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      this.startSlideShow();
    },
  },
};
</script>

<style scoped>
.cursor {
  animation: blink 0.7s step-start infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
